export const importLottie = () => import('lottie-react');
